// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__MspGa","topBottomGutter":"Layout_topBottomGutter__1DrI4"};